module.exports = __webpack_public_path__ + "media/8_4.1c8f0a71.wav";